import { isBrandInNAM } from "@faire/help-center-self-serve/utils/isBrandInNAM";
import { Button } from "@faire/web--source/slate/Button";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import brandPortalAccountRoute from "@faire/web-api--source/routes/brand-portal/account";
import React from "react";
import { Bold } from "../common/Bold";
import { RowWithBullet } from "../common/RowWithBullet";
export var UpdatePayoutsIA = function UpdatePayoutsIA(_ref) {
  var brand = _ref.brand;
  if (isBrandInNAM(brand)) {
    return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "gbEM9B",
      defaultMessage: [{
        "type": 0,
        "value": "Vous pouvez choisir le délai de paiement sur votre compte après l'expédition de la commande. Les paiements sont effectués en fonction de l'option de paiement sélectionnée et apparaissent sur votre compte dans les 3 à 5 jours ouvrés après l'émission du paiement, en fonction du délai de traitement de votre banque. Les frais de traitement des paiements sont basés sur l'option de paiement que vous avez choisie."
      }]
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg
    /* eslint-disable-next-line @faire/no-dollar-symbol-in-strings */, {
      id: "CYGSaU",
      /* eslint-disable-next-line @faire/no-dollar-symbol-in-strings */
      defaultMessage: [{
        "children": [{
          "type": 0,
          "value": "Paiement le jour suivant"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": " : 3,5 % + 0,30 $"
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    }))), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg
    /* eslint-disable-next-line @faire/no-dollar-symbol-in-strings */, {
      id: "zaIu+A",
      /* eslint-disable-next-line @faire/no-dollar-symbol-in-strings */
      defaultMessage: [{
        "children": [{
          "type": 0,
          "value": "Paiement à 30 jours"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": " : 2,4 % + 0,30 $"
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    }))), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg
    /* eslint-disable-next-line @faire/no-dollar-symbol-in-strings */, {
      id: "bZnAZH",
      /* eslint-disable-next-line @faire/no-dollar-symbol-in-strings */
      defaultMessage: [{
        "children": [{
          "type": 0,
          "value": "Paiement à 60 jours"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": " : 1,9 % + 0,30 $"
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })))), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "q1sTS9",
      defaultMessage: [{
        "type": 0,
        "value": "Pour modifier votre option de paiement et les frais de traitement des paiements correspondants, accédez aux "
      }, {
        "children": [{
          "type": 0,
          "value": "Paramètres du compte"
        }],
        "type": 8,
        "value": "AccountSettingLinkFormatting"
      }, {
        "type": 0,
        "value": " et sélectionnez l'onglet "
      }, {
        "children": [{
          "type": 0,
          "value": "Paiements"
        }],
        "type": 8,
        "value": "PayoutLinkFormatting"
      }, {
        "type": 0,
        "value": "."
      }],
      values: {
        AccountSettingLinkFormatting: function AccountSettingLinkFormatting(chunks) {
          return PayoutsLinkFormatting(chunks, "my-account");
        },
        PayoutLinkFormatting: function PayoutLinkFormatting(chunks) {
          return PayoutsLinkFormatting(chunks, "payment");
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "oGyzWH",
      defaultMessage: [{
        "type": 0,
        "value": "Les modifications s'appliqueront à toutes les commandes passées après la mise à jour des paramètres de paiement. Contactez-nous si vous souhaitez modifier votre option de paiement dans vos commandes existantes."
      }]
    })));
  }
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "iMNCJo",
    defaultMessage: [{
      "type": 0,
      "value": "Vous pouvez choisir le délai de paiement sur votre compte après l'expédition de la commande. Les paiements sont effectués en fonction de l'option de paiement sélectionnée et apparaissent sur votre compte dans les 3 à 5 jours ouvrés après l'émission du paiement, en fonction du délai de traitement de votre banque. Les frais de traitement des paiements sont basés sur l'option de paiement que vous avez choisie."
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "3kOCho",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Paiement ACH le jour suivant"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " : des frais de 3 % sont appliqués à la commande et aux frais d'expédition"
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "ljpEqK",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Paiement ACH à 30 jours"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " : aucuns frais de paiement"
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  })))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "S45UJf",
    defaultMessage: [{
      "type": 0,
      "value": "Pour modifier votre option de paiement et les frais de traitement des paiements correspondants, accédez aux "
    }, {
      "children": [{
        "type": 0,
        "value": "Paramètres du compte"
      }],
      "type": 8,
      "value": "AccountSettingLinkFormatting"
    }, {
      "type": 0,
      "value": " et sélectionnez l'onglet "
    }, {
      "children": [{
        "type": 0,
        "value": "Paiements"
      }],
      "type": 8,
      "value": "PayoutLinkFormatting"
    }, {
      "type": 0,
      "value": "."
    }],
    values: {
      AccountSettingLinkFormatting: function AccountSettingLinkFormatting(chunks) {
        return PayoutsLinkFormatting(chunks, "my-account");
      },
      PayoutLinkFormatting: function PayoutLinkFormatting(chunks) {
        return PayoutsLinkFormatting(chunks, "payment");
      }
    }
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "JR23KI",
    defaultMessage: [{
      "type": 0,
      "value": "Les modifications s'appliqueront à toutes les commandes passées après la mise à jour des paramètres de paiement. Contactez-nous si vous souhaitez modifier votre option de paiement sur vos commandes existantes."
    }]
  })));
};
var PayoutsLinkFormatting = function PayoutsLinkFormatting(chunks, tab) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalAccountRoute({
      tab: tab
    }),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};